import { render, staticRenderFns } from "./dentition-space.vue?vue&type=template&id=5ea369cf&scoped=true"
import script from "./dentition-space.vue?vue&type=script&lang=js"
export * from "./dentition-space.vue?vue&type=script&lang=js"
import style0 from "./dentition-space.vue?vue&type=style&index=0&id=5ea369cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea369cf",
  null
  
)

export default component.exports